import { render, staticRenderFns } from "./certifiedParenting.vue?vue&type=template&id=342fc805&scoped=true&lang=html&"
import script from "./certifiedParenting.vue?vue&type=script&lang=js&"
export * from "./certifiedParenting.vue?vue&type=script&lang=js&"
import style0 from "./certifiedParenting.vue?vue&type=style&index=0&id=342fc805&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "342fc805",
  null
  
)

export default component.exports